import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Wrapper = styled(Link)`
  width: 45px;
  height: 45px;
  display: block;
  color: inherit;
  z-index: 7;
  > * {
    max-width: 100%;
    max-height: 100%;
  }
  ${({ theme }) => theme.media.md.min`
    width: 80px;
    height: 80px;
   `}
  ${({ theme }) => theme.media.lg.min`
   `}
`;

function Logo(props) {
  return (
    <Wrapper className={props.className} to="/" aria-label="Homepage">
      <svg
        height="80"
        viewBox="0 0 80 80"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m39.7243749 79.4874156c-.1910782-.3479957-.1910782-12.8594991 0-37.5345102-4.6863689-.2856738-8.245983-.4805897-10.6788429-.5847473-2.4689213-.1058547-2.4642175-.078252-1.6807898 2.3266622 3.655561 11.2179307 11.1449014 34.2516706 11.2449856 34.5467243.2106215.6187815.1251707 1.1574352-.4444998 1.5200214-.5367449.3414154-1.0003208.1133587-1.4165985-.2741504-1.4827116-1.3801324-24.88102-23.303871-35.10373416-32.8782381-.71835994-.672915-1.36564172-1.3739687-1.57312727-2.3968746-.31122834-1.5323489.41105136-3.1290149 1.75421983-3.8434679 1.4181664-.754115 3.06289448-.4408382 4.25946423.9060637 3.19564342 3.5974558 22.13640927 25.1444048 28.47229717 32.3433362.2929362-.3572265-6.8229823-21.6841581-10.2156587-32.0975922-.7052941-2.1647982-.4643599-2.5155928 1.7178968-2.6037606 2.8417334-.1143411 7.3965292-.3624075 13.6643875-.7441996v-10.1550945c-18.2657847 5.3524125-30.52106466 8.9482603-36.7658399 10.7875438-.41470979.122202-.85006362.2575352-1.27261292.2468157-.86574263-.0219748-1.29874461-.8283475-.88455744-1.6114052.16227774-.3063087.4241172-.5630402.66217683-.8211117 10.85431683-11.7723955 21.70941773-23.5437191 32.56922213-35.31102287 1.285679-1.39326377 2.7605511-1.63043216 3.9103451-.66728732 1.3235697 1.1089297 1.3324544 2.82860149-.067681 4.19158276-3.156446 3.07273752-31.21351068 29.97192023-31.60052088 30.40981083 2.07119712-.7064134 13.22101978-4.5586355 33.44946808-11.556666.0733427-15.0147688.0733427-22.5897752 0-22.72501925.6363064-1.11830924 1.3806674-1.26087826 2.2503297-.42529517 6.0685605 5.83273438 12.1906912 11.66868462 18.2190088 17.54456492 1.5969072 1.5567357 1.0342921 3.5167918-1.1424771 4.1701438-3.4539116 1.0365732-9.1460889 2.5642771-17.0765317 4.5831115v11.3524602c10.5324616-.4289578 30.6336486-1.2579304 34.4616786-1.4272982 1.5057075-.0664607 2.6547177.5054232 3.2659378 1.942369.6104361 1.4342657.2547838 2.7206028-.8173992 3.7866545-2.5298081 2.5150568-32.9358497 32.4459753-33.8893948 33.7733142-1.0687858 1.2217522-4.5474583 4.5445699-5.2711521 3.2265621zm2.3292996-3.9750493 27.6739743-32.3714751-27.6352993-1.2148942zm.3955291-71.04439327c-.0993004.02036698-.1986007.04073399-.2979011.06136899 0 5.86998458.0047037 11.74023708-.0054876 17.61022168-.0013067.7886854.3768188.7364279.9185286.550445 3.5047812-1.203797 7.010869-2.4030383 10.5232285-3.5824485.6990225-.2344886.9637365-.4590616.364537-1.1566314-3.8491969-4.4810086-7.6717394-8.98586799-11.5029054-13.48295577zm16.9361263 71.54378667c.0182923 2.2615414-1.6860162 4.0157833-3.8745446 3.9879128-2.1205859-.0276027-3.7849129-1.7727331-3.777596-3.9611141.0073168-2.203924 1.6632815-3.897333 3.8178389-3.9040329 2.162658-.0066997 3.8162708 1.6655384 3.8343017 3.8772342z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    </Wrapper>
  );
}

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;
